import * as XLSX from 'xlsx';
class Worksheet {
    constructor(name) {
        this.name = name;
        this.rows = [];
    }
    addRow(values) {
        if (Array.isArray(values)) {
            this.rows.push(values);
            return values;
        }
        this.rows.push([values]);
        return values;
    }
    toSheet() {
        return XLSX.utils.aoa_to_sheet(this.rows);
    }
    get sheetName() {
        return this.name;
    }
}
export class Workbook {
    constructor() {
        this.worksheets = [];
        this.xlsx = {
            writeBuffer: async () => {
                const workbook = XLSX.utils.book_new();
                this.worksheets.forEach((worksheet) => {
                    XLSX.utils.book_append_sheet(workbook, worksheet.toSheet(), worksheet.sheetName);
                });
                return XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            },
        };
    }
    addWorksheet(name) {
        const worksheet = new Worksheet(name);
        this.worksheets.push(worksheet);
        return worksheet;
    }
}
